module.exports = __webpack_public_path__ + "static/media/map.8f7b41e7.svg";